import { RootState } from "store";

export const selectConstellation = (state: RootState) => state.constellation;
